import PropTypes from "prop-types";
import React from "react";
import ImmutablePropTypes from "react-immutable-proptypes";

import withScrollableView from "../../components/scrollable/withScrollableView";
import { PropTypeShapes } from "../../types";
import TimelineScrollBackgroundView from "./TimelineScrollBackgroundView";

const TimelineSyncScroller = props => {
  return (
    <div className="timelineSyncScroller">
      <TimelineScrollBackgroundView
        viewIds={props.viewIds}
        dragHoverDate={props.dragHoverDate}
        dragHoverScreenYPixel={props.dragHoverScreenYPixel}
        key="timelineScrollBackground"
      />
      {props.children}
    </div>
  );
};

TimelineSyncScroller.propTypes = {
  // Any special instructions when placing the data?
  children: PropTypes.element,
  // Shown when dragging items...
  dragHoverDate: PropTypeShapes.date,
  dragHoverScreenYPixel: PropTypes.number,

  viewIds: ImmutablePropTypes.listOf(PropTypes.string).isRequired,

  // Starting scroll positions
  initialScrollLeft: PropTypes.number,
  initialScrollTop: PropTypes.number,

  // Also accessed by ScrollableView
  requestViewBoundsForZoom: PropTypes.func.isRequired
};

const scrollableViewOptions = {
  scrollHorizontally: true,
  scrollVertically: false,
  showHorizontalScrollbar: false,
  horizontalIsInfinite: true,
  allowPinchZoom: true,
  invertZoom: true,
  allowCtrlScrollZoom: true,
  disableCtrlScroll: false
};

export default withScrollableView(TimelineSyncScroller, scrollableViewOptions);
